import gql from 'graphql-tag';

export const reviewFields = gql`
  fragment reviewFields on Review {
    content
    createdAt
    tool {
      name
      imageUrl
      thumbUrl
      canonicalUrl
    }
    user {
      id
      title
      companyName
      path
      username
      displayName
      imageUrl
      thumbUrl
    }
  }
`;

export const descriptionFields = gql`
  fragment descriptionFields on StackItem {
    tool {
      name
      canonicalUrl
      imageUrl
      thumbUrl
    }
    description
    stack {
      owner {
        ... on Company {
          __typename
          name
          path
          imageUrl
          thumbUrl
        }
        ... on User {
          __typename
          displayName
          path
          imageUrl
          thumbUrl
        }
      }
    }
  }
`;

export const companyStackFields = gql`
  fragment companyStackFields on Stack {
    canonicalUrl
    owner {
      ... on Company {
        name
        imageUrl
        thumbUrl
      }
    }
  }
`;

export const stackupServiceFields = gql`
  fragment stackupServiceFields on Tool {
    name
    imageUrl
    thumbUrl
    path
  }
`;

export const stackupStackDecisionFields = gql`
  fragment stackupStackDecisionFields on StackDecision {
    id
    user {
      id
      username
      displayName
      title
      companyName
      imageUrl
      thumbUrl
    }
    publicId
    publishedAt
    upvotesCount
    viewCount
    htmlContent
    private
    services {
      name
      imageUrl
      thumbUrl
    }
    topics {
      name
    }
    company {
      name
      imageUrl
      thumbUrl
      path
      features {
        slug
      }
    }
  }
`;

export const relatedStackupFields = gql`
  fragment relatedStackupFields on Stackup {
    id
    path
    services {
      id
      name
      imageUrl
      thumbUrl
    }
  }
`;
